import { lazy } from "react";

export { RAG_DOCUMENTS_PATH } from "./rag-documents-path";
export const RagDocumentsPage = lazy(() => import("./rag-documents"));
